import { Injectable, Inject } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {AttributeGroup} from '@emm/core/models/attribute-group.model';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {standardRetry} from '@emm/core/util/rx.util';
import {API} from '@emm/core/util/api-constants';

@Injectable({ providedIn: 'root' })
export class AttributeGroupService {
    constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) {}

    public getAttributeGroup(attributeGroup: AttributeGroup): Observable<AttributeGroup> {
        return this.http
            .get<AttributeGroup>(`${this.apiUrl}/attribute-groups/${attributeGroup}?projection=details`)
            .pipe(standardRetry());
    }

    public getAttributeGroups(): Observable<AttributeGroup[]> {
        const url = `${this.apiUrl}${API.AllAttributeGroups}`;
        return this.http.get(url).pipe(
            map((response: any) => response),
            standardRetry()
        );
    }

    public updateAttributeGroup(attributeGroupId: string, attributeGroup: AttributeGroup): Observable<AttributeGroup> {
        return this.http
            .patch(`${this.apiUrl}/attribute-groups/${attributeGroupId}`, attributeGroup)
            .pipe(standardRetry());
    }

    public createAttributeGroup(attributeGroup: AttributeGroup): Observable<any> {
        const headers = new HttpHeaders({'Content-Type':'application/json; charset=utf-8'});
        const options = { headers };
        return this.http
            .post(`${this.apiUrl}/attribute-groups`, attributeGroup, options)
            .pipe(standardRetry());
    }

    public deleteAttributeGroup(attributeGroup: AttributeGroup): Observable<any> {
        return this.http
            .delete(`${this.apiUrl}/attribute-groups/${attributeGroup}`)
            .pipe(standardRetry());
    }
}
